import { apiProvider } from './utilities/Provider';

export const SpreadsheetIntegrationService = {
    getIntegrations: (workflowId) =>
        apiProvider.get(`Workflow/${workflowId}/integrations`),
    createGoogleSheets: (workflowId, body) =>
        apiProvider.post(`Workflow/${workflowId}/integrations/google-sheets`, body),
    updateIntegration: (workflowId, integrationId, body) =>
        apiProvider.put(`Workflow/${workflowId}/integrations/${integrationId}`, body),
    deleteIntegration: (workflowId, integrationId, revokeAccess = true) =>
        apiProvider.delete(`Workflow/${workflowId}/integrations/${integrationId}?revokeAccess=${revokeAccess}`),
};
